var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "notifications-container",
      attrs: { "aria-live": "assertive" }
    },
    [
      _c(
        "div",
        { staticClass: "notifications-content" },
        _vm._l(_vm.notifications, function(n) {
          return _c(
            "div",
            { key: n.id, staticClass: "notification", class: [n.level] },
            [
              _c("div", { staticClass: "p-4" }, [
                _c("div", { staticClass: "flex items-start" }, [
                  _c("div", { staticClass: "flex-shrink-0" }, [
                    n.level === _vm.levels.ERROR
                      ? _c(
                          "svg",
                          {
                            staticClass: "icon h-6 w-6 text-red-400",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "currentColor",
                              stroke: "none",
                              viewBox: "0 0 24 24",
                              "aria-hidden": "true"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                d:
                                  "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                "clip-rule": "evenodd"
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    n.level === _vm.levels.SUCCESS
                      ? _c(
                          "svg",
                          {
                            staticClass: "icon h-6 w-6 text-green-400",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor",
                              "aria-hidden": "true"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d:
                                  "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    n.level === _vm.levels.INFO
                      ? _c(
                          "svg",
                          {
                            staticClass: "icon w-6 h-6 text-blue-400",
                            attrs: {
                              viewBox: "0 0 20 20",
                              xmlns: "http://www.w3.org/2000/svg",
                              stroke: "none",
                              fill: "currentColor"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                d:
                                  "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                "clip-rule": "evenodd"
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "text-content" }, [
                    _c("p", { staticClass: "headline" }, [
                      _vm._v(_vm._s(n.headline))
                    ]),
                    _c("p", { staticClass: "details" }, [
                      _vm._v(_vm._s(n.details))
                    ])
                  ]),
                  _c("div", { staticClass: "ml-4 flex-shrink-0 flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        on: {
                          click: function($event) {
                            return _vm.remove(n.id)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Close")
                        ]),
                        _c(
                          "svg",
                          {
                            staticClass: "h-5 w-5",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                              "aria-hidden": "true"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                d:
                                  "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                "clip-rule": "evenodd"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }